// Whenever the facet filters on a taxonomy term archive are set, this code
// scrolls the page down to the filtered section of the page automatically. 

jQuery(document).ready(function ($) {
// tests if the query string starts with wp facet's query
// so long as no other query strings are present, this should work
// in future, if we make use of more query strings, can be changed to 
// check for contains
	if (window.location.search.startsWith('?fwp_by')) {
		jQuery('html, body').animate({
			scrollTop: ($('#facets-title').offset().top)
		}, 500);
	}
})
